export class SpawnPointObjects {
   static readonly position1 = 45;
   static readonly position2 = 55;
   static readonly position3 = 740;
   static readonly position4 = 755;
   static readonly endLevelPosition = 700;
  }
  